/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 2/16/16.
 */

'use strict';

angular
    .module('prism-ui.partner')
    .service('PartnerEditService',

        function (_, $routeParams, $location, $q, $route, BreadcrumbService, ContentResourceFactory,
                  DeliveryTemplatesResourceFactory, EmailTemplatesResourceFactory, NetworkResourceFactory,
                  NotificationService, PackageResourceFactory, PartnerResourceFactory, PermissionsService,
                  LivefeedsResourceFactory, TransformTemplatesResourceFactory, UtilsService,
                  MediaConversionTemplateService, PaginationService) {

            var self = this;
            var originalPartnerData;

            self.partnerObject = null;
            self.editorForm = null;
            self.deliveryTemplates = [];

            self.tabRevertFunction = null;
            self.tabSaveSuccessFunction = null;
            self.tabSaveErrorFunction = null;

            self.saveDisabled = null;

            self.parentRoute = '/system/partners/search';

            self.viewStates = {
                SYSTEM_PARTNERS_DELIVERYENDPOINTS_VIEW_STATE: 'SYSTEM_PARTNERS_DELIVERYENDPOINTS_VIEW_STATE',
                SYSTEM_PARTNERS_EMAIL_VIEW_STATE: 'SYSTEM_PARTNERS_EMAIL_VIEW_STATE',
                SYSTEM_PARTNERS_DUE_DATE_TEMPLATES_VIEW_STATE: 'SYSTEM_PARTNERS_DUE_DATE_TEMPLATES_VIEW_STATE'
            };

            self.resetBreadcrumbs = function () {
                BreadcrumbService.clearBreadcrumbs();
                BreadcrumbService.addBreadcrumb({
                    name: 'Partners',
                    location: '/system/partners/search',
                    params: angular.copy($location.search())
                });
            };

            //================//
            // Partner Editor //
            //================//

            var closeEditView = function (toRoute) {
                self.resetBreadcrumbs();
                self.partnerObject = null;
                self.editorForm = null;

                $location.path(toRoute || self.parentRoute);
            };

            self.getViewPermissions = function () {
                let deliveryEndpointsViewState = self.viewStates.SYSTEM_PARTNERS_DELIVERYENDPOINTS_VIEW_STATE;
                let emailEndpointsViewState = self.viewStates.SYSTEM_PARTNERS_EMAIL_VIEW_STATE;
                let dueDateTemplatesViewState = self.viewStates.SYSTEM_PARTNERS_DUE_DATE_TEMPLATES_VIEW_STATE;

                return $q.all({
                    deliveryEndpointsRead: PermissionsService.canRead(deliveryEndpointsViewState),
                    deliveryEndpointsWrite: PermissionsService.canWrite(deliveryEndpointsViewState),
                    emailEndpointsRead: PermissionsService.canRead(emailEndpointsViewState),
                    emailEndpointsWrite: PermissionsService.canWrite(emailEndpointsViewState),
                    dueDateTemplatesRead: PermissionsService.canRead(dueDateTemplatesViewState),
                    dueDateTemplatesWrite: PermissionsService.canWrite(dueDateTemplatesViewState)
                });
            };

            self.getAllPartners = (queryParams = {}, queryHandler = () => {
            }) => {
                return PartnerResourceFactory.query(queryParams, queryHandler).$promise;
            };

            self.getEditData = function () {
                var partnerReady = $q.defer();
                if ($routeParams.id > -1) {
                    self.partnerObject = PartnerResourceFactory.get({id: $routeParams.id});
                    self.partnerObject.$promise.then(function (partnerData) {
                        originalPartnerData = angular.copy(partnerData);
                        partnerReady.resolve(partnerData);

                    });
                } else {
                    self.partnerObject = new PartnerResourceFactory({});
                    partnerReady.resolve(self.partnerObject);
                }
                self.deliveryTemplates = DeliveryTemplatesResourceFactory.query();
                return $q.all({
                    partner: partnerReady.promise,
                    deliveryTemplates: self.deliveryTemplates.$promise,
                    partnersWithoutChildPartners: self.getAllPartners({fetchLimit: 0, includeChildren: false})
                });
            };

            self.revertEditData = function () {
                if (self.partnerObject.id) {
                    self.partnerObject = _.cloneDeep(originalPartnerData);
                    self.editorForm.$setPristine();
                    if (self.tabRevertFunction) {
                        self.tabRevertFunction();
                    }
                    return self.partnerObject;
                } else {
                    closeEditView();
                }
            };

            self.saveEditData = function () {
                if (!self.partnerObject.embargoEnabledFlag) {
                    delete self.partnerObject.embargoDeliveryEndpoint;
                    delete self.partnerObject.embargoEmailEndpoint;
                }

                if (!self.partnerObject.approvalEnabledFlag) {
                    delete self.partnerObject.autoApprovalFlag;
                    delete self.partnerObject.approvalDeliveryEndpoint;
                    delete self.partnerObject.approvalEmailEndpoint;
                }

                var savePromise = (self.partnerObject.id > -1) ?
                    self.partnerObject.$update() :
                    self.partnerObject.$save();

                savePromise.then(
                    function (partnerData) {
                        originalPartnerData = angular.copy(partnerData);
                        self.editorForm.$setPristine();
                        $route.updateParams({id: partnerData.id});
                        if (self.tabSaveSuccessFunction) {
                            self.tabSaveSuccessFunction();
                        }
                    },
                    function () {
                        if (self.tabSaveErrorFunction) {
                            self.tabSaveErrorFunction();
                        }
                    });
                return savePromise;
            };

            self.showUnsavedChangesNotification = function () {
                NotificationService.createWarningNotification('You have unsaved changes. Please save or revert.', '');
            };

            self.exitEdit = function (toRoute) {
                if (self.canExitEditView()) {
                    closeEditView(toRoute);
                } else {
                    self.showUnsavedChangesNotification();
                }
            };

            self.changeEditTab = function (tabName) {
                if (self.canExitEditView()) {
                    $route.updateParams({editView: tabName});
                }
            };

            self.canExitEditView = function () {
                return !self.editorForm || (self.partnerObject.id && self.editorForm.$pristine);
            };

            //==================//
            // Partner Planners //
            //==================//

            self.deletePlanner = function (planner) {
                return PartnerResourceFactory.deletePlanner({id: planner.id}).$promise;
            };

            // The server maintains a planner's weekly schedule as a set
            // of integers which each represent the number of minutes into
            // the week after which the planner should be delivered.
            //
            // The UI presents this data as an array of weekdays, and a time
            // of day at which the planner will run.

            var getScheduleSet = function (planner) {
                // Create PlannerDTO.weeklySchedule

                var scheduleSet = [];
                var hoursAndMinutes = planner.scheduleTimeOfDay.split(':');
                var timeOfDayOffset = Number(hoursAndMinutes[0]) * 60 + Number(hoursAndMinutes[1]);
                var dayOfWeekOffsets = {
                    'Sun': 0,
                    'Mon': UtilsService.constants.MINUTES_PER_DAY,
                    'Tue': UtilsService.constants.MINUTES_PER_DAY * 2,
                    'Wed': UtilsService.constants.MINUTES_PER_DAY * 3,
                    'Thu': UtilsService.constants.MINUTES_PER_DAY * 4,
                    'Fri': UtilsService.constants.MINUTES_PER_DAY * 5,
                    'Sat': UtilsService.constants.MINUTES_PER_DAY * 6
                };

                planner.scheduleDays.forEach(function (day) {
                    scheduleSet.push(dayOfWeekOffsets[day] + timeOfDayOffset);
                });

                return scheduleSet;
            };

            var getDaysAndTime = function (planner) {
                // Interpret PlannerDTO.weeklySchedule for UI

                if (planner.weeklySchedule !== undefined) {
                    planner.scheduleDays = [];
                    planner.weeklySchedule.forEach(function (minutesIntoWeek) {
                        planner.scheduleDays.push(UtilsService.minutesToWeekday(minutesIntoWeek));
                        planner.scheduleTimeOfDay = UtilsService.minutesToTimeOfDay(minutesIntoWeek);
                    });
                }
            };

            var createPlannerScheduleLabel = function (scheduleDays, scheduleTime) {
                // Create a compact label to represent a planner's weekly
                // schedule in the search view.
                //
                // Example: 'Mo,We,Fr @ 08:30 AM'

                var label = '';
                scheduleDays.forEach(function (day) {
                    if (label.length > 0) {
                        label += ',';
                    }
                    label += day.substring(0, 2);
                });

                var meridian = 'AM';
                var parts = scheduleTime.split(':');
                parts[0] = Number(parts[0]);
                parts[1] = Number(parts[1]);

                if (parts[0] === 0) {
                    parts[0] = 12;
                } else if (parts[0] >= 12) {
                    if (parts[0] > 12) {
                        parts[0] -= 12;
                    }
                    meridian = 'PM';
                }

                label += ' @ ' + UtilsService.timeToString(parts[0], parts[1]) + ' ' + meridian;
                return label;
            };

            //
            // Planner <==> DTO converters - add/remove properties
            // only needed by the server and/or the UI
            //

            var plannerFromDTO = function (plannerDTO) {
                var planner = _.cloneDeep(plannerDTO, true);

                // these fields must be Number()'s for the editor UI
                UtilsService.convertToNumber(planner, 'lookBack');
                UtilsService.convertToNumber(planner, 'lookForward');
                UtilsService.convertToNumber(planner, 'frequency');

                // setup schedule properties for UI
                if (planner.weeklySchedule !== undefined) {
                    planner.frequency = undefined;
                    planner.scheduleType = 'weekly';
                    getDaysAndTime(planner);

                    planner.scheduleLabel = createPlannerScheduleLabel(planner.scheduleDays, planner.scheduleTimeOfDay);
                } else {
                    planner.scheduleType = 'recurring';
                    planner.weeklySchedule = [];
                    planner.scheduleDays = [];
                    planner.scheduleTimeOfDay = '00:00';

                    planner.scheduleLabel = planner.frequency + ' hour';
                    if (planner.frequency > 1) {
                        planner.scheduleLabel += 's';
                    }
                }

                // coerce searchBySunrise to a default of false
                // since it's excluded from the DTO unless true
                if (plannerDTO.searchBySunrise === undefined) {
                    planner.searchBySunrise = false;
                }
                return planner;
            };

            var plannersFromDTO = function (planners) {
                var modifiedPlanners = [];
                planners.forEach(function (planner) {
                    modifiedPlanners.push(plannerFromDTO(planner));
                });
                return modifiedPlanners;
            };

            var plannerToDTO = function (planner) {
                var dto = _.cloneDeep(planner);

                // remove extraneous schedule
                // properties used only by the UI
                if (planner.scheduleType === 'recurring') {
                    delete dto.weeklySchedule;
                } else {
                    dto.weeklySchedule = getScheduleSet(planner);
                    dto.frequency = 1;
                }

                delete dto.scheduleType;
                delete dto.scheduleDays;
                delete dto.scheduleTimeOfDay;
                delete dto.scheduleLabel;

                return dto;
            };

            self.savePartnerPlanner = function (planner) {
                var dto = plannerToDTO(planner);
                var promise = $routeParams.plannerId > -1 ?
                    PartnerResourceFactory.updatePlanner({id: planner.id}, dto).$promise :
                    PartnerResourceFactory.createPlanner({id: $routeParams.id}, dto).$promise;
                promise.then(function (data) {
                    var newPlanner = plannerFromDTO(data);
                    self.originalPlannerData = _.cloneDeep(newPlanner);
                    self.plannerObject = _.cloneDeep(newPlanner);
                    self.editorForm.$setPristine();
                });
                return promise;
            };

            self.revertPartnerPlanner = function () {
                self.editorForm.$setPristine();
                if ($routeParams.plannerId > -1) {
                    self.plannerObject = _.cloneDeep(self.originalPlannerData);
                } else {
                    self.closePlannerEditView();
                }
            };

            self.closePlannerEditView = function () {
                if (self.editorForm && self.editorForm.$dirty) {
                    self.showUnsavedChangesNotification();
                } else {
                    self.resetBreadcrumbs();
                    self.plannerObject = _.cloneDeep(self.originalPlannerData);
                    self.editorForm = null;
                    $location.path('/system/partners/edit/' + self.partnerObject.id + '/planner');
                }
            };

            var getPartnerPromise = function () {
                if (!self.partnerObject || self.partnerObject.id !== $routeParams.id) {
                    return PartnerResourceFactory.get({id: $routeParams.id}).$promise;
                } else {
                    var partnerDeferred = $q.defer();
                    partnerDeferred.resolve(self.partnerObject);
                    return partnerDeferred.promise;
                }
            };

            self.deliverOffCyclePlanners = function (plannersList, message) {
                var plannerIds = [];
                _.forEach(plannersList, function (planner) {
                    plannerIds = _.concat(plannerIds, planner.id);
                });
                return PartnerResourceFactory.deliverOffCyclePlanners({
                    plannerId: plannerIds,
                    message: message
                }).$promise;
            };

            self.getPartnerPlanners = function (queryParams) {
                var plannersPromise = PartnerResourceFactory.getAllPlanners(queryParams).$promise;

                return plannersPromise.then((response) => {
                    let returnObj = {
                        planners: plannersFromDTO(response),
                        headers: response.$httpHeaders()
                    };
                    delete returnObj.planners.$httpHeaders;
                    return returnObj;
                });
            };

            self.getPlannerSearchViewData = function () {
                var partnerPromise = getPartnerPromise();
                var plannersPromise = PartnerResourceFactory.getPlanners({id: $routeParams.id}).$promise;

                return $q.all({
                    partnerObject: partnerPromise,
                    planners: plannersPromise
                }).then(function (data) {
                    data.planners = plannersFromDTO(data.planners);
                    self.partnerObject = data.partnerObject;
                    return data;
                });
            };

            self.getPlannerEditViewData = function () {
                var partnerPromise = getPartnerPromise();
                var plannerPromise;
                if ($routeParams.plannerId > -1) {
                    plannerPromise = PartnerResourceFactory
                        .getPlanner({id: $routeParams.plannerId})
                        .$promise;
                } else {
                    var plannerDeferred = $q.defer();
                    self.plannerObject = {
                        enabledFlag: false,
                        searchBySunrise: false,
                        scheduleDays: [],
                        scheduleTimeOfDay: '00:00',
                        scheduleType: 'recurring'
                    };
                    plannerDeferred.resolve(self.plannerObject);
                    plannerPromise = plannerDeferred.promise;
                }

                return $q.all({
                    partnerObject: partnerPromise,
                    availableDeliveryEndpoints: PartnerResourceFactory.getDeliveryEndpoints(
                        {
                            id: $routeParams.id
                        }).$promise,
                    availableEmailEndpoints: PartnerResourceFactory.getEmailEndpoints(
                        {
                            partnerId: $routeParams.id
                        }).$promise,
                    availableTransformTemplates: TransformTemplatesResourceFactory.query().$promise,
                    plannerObject: plannerPromise,
                }).then(function (data) {
                    self.partnerObject = data.partnerObject;
                    self.plannerObject = plannerFromDTO(data.plannerObject);
                    data.plannerObject = self.plannerObject;
                    self.originalPlannerData = _.cloneDeep(self.plannerObject);
                    return data;
                });
            };

            //====================//
            // Delivery Endpoints //
            //====================//

            self.supportedEndpointTypes = {
                'S3': 'Amazon S3',
                'AppleNews': 'Apple News',
                'ASPERA': 'Aspera',
                'ASPERA_KEY': 'Aspera Key',
                'ASPERA_CLI': 'Aspera Share',
                'IVI': 'Freewheel IVI',
                'FTP': 'FTP',
                'GS': 'Google Storage',
                'iTunes': 'iTunes',
                'Netflix': 'Netflix',
                'Network': 'Network',
                'SFTP': 'SFTP',
                'UPLYNK': 'UpLynk',
                'Vantage': 'Vantage'
            };

            self.getEndpointTypeLabel = function (type) {
                return self.supportedEndpointTypes[type];
            };

            //
            // Planner <==> DTO converters - add/remove properties
            // only needed by the server and/or the UI
            //

            var deliveryEndpointFromDTO = function (deliveryEndpointDTO) {
                var deliveryEndpoint = _.cloneDeep(deliveryEndpointDTO, true);

                // these fields default to 0
                ['maxRetries', 'bandwidthThreshold'].forEach(function (field) {
                    if (!UtilsService.hasData(deliveryEndpointDTO[field])) {
                        deliveryEndpoint[field] = 0;
                    }
                });

                // these fields must be Number()'s for the editor UI
                UtilsService.convertToNumber(deliveryEndpoint, 'maxRetries');
                UtilsService.convertToNumber(deliveryEndpoint, 'bandwidthThreshold');
                UtilsService.convertToNumber(deliveryEndpoint, 'bandwidthWarningDelay');

                return deliveryEndpoint;
            };

            var deliveryEndpointsFromDTO = function (deliveryEndpoints) {
                var modifiedDeliveryEndpoints = [];
                deliveryEndpoints.forEach(function (deliveryEndpoint) {
                    modifiedDeliveryEndpoints.push(deliveryEndpointFromDTO(deliveryEndpoint));
                });
                return modifiedDeliveryEndpoints;
            };

            self.getDeliveryEndpointSearchViewData = function (showHidden) {
                var partnerPromise = getPartnerPromise();
                var deliveryEndpointsPromise =
                    PartnerResourceFactory
                        .getDeliveryEndpoints({
                            id: $routeParams.id,
                            includeHidden: showHidden
                        }).$promise;

                return $q.all({
                    partnerObject: partnerPromise,
                    deliveryEndpoints: deliveryEndpointsPromise
                })
                    .then(function (data) {
                        data.deliveryEndpoints = deliveryEndpointsFromDTO(data.deliveryEndpoints);
                        self.partnerObject = data.partnerObject;
                        return data;
                    });
            };

            var endpointTypeMap = {
                applenews: 'AppleNews',
                aspera: 'ASPERA',
                aspera_key: 'ASPERA_KEY',
                aspera_cli: 'ASPERA_CLI',
                ftp: 'FTP',
                itunes: 'iTunes',
                ivi: 'IVI',
                netflix: 'Netflix',
                network: 'Network',
                s3: 'S3',
                sftp: 'SFTP',
                uplynk: 'UPLYNK',
                vantage: 'Vantage'
            };

            self.getPartnerDeliveryEndpointEditData = function () {
                var partnerPromise = getPartnerPromise();
                var deliveryEndpointPromise;
                if ($routeParams.endpointId > -1) {
                    // Get existing endpoint
                    deliveryEndpointPromise = PartnerResourceFactory
                        .getDeliveryEndpoint({endpointId: $routeParams.endpointId})
                        .$promise;
                } else {
                    // Construct new endpoint
                    var deliveryEndpointDeferred = $q.defer();
                    var type = $routeParams.endpointType;
                    self.endpointObject = {
                        type: endpointTypeMap[type],
                        maxRetries: '0',
                        bandwidthThreshold: '0',
                    };

                    // Set protocol specific defaults
                    switch (type) {
                        case 'aspera':
                        case 'aspera_key':
                            self.endpointObject.tcpPort = 22;
                            self.endpointObject.udpPort = 33001;
                            self.endpointObject.transferPolicy = '-Q';
                            self.endpointObject.resumePolicy = '0';
                            break;

                        case 'aspera_cli':
                            self.endpointObject.cipher = 'none';
                            break;

                        case 'ftp':
                            self.endpointObject.serverPort = 21;
                            break;

                        case 'itunes':
                            self.endpointObject.deliveryMethod = 'Auto';
                            self.endpointObject.transferSpeed = 10000;
                            self.endpointObject.logLevel = 'eXtreme';
                            break;

                        case 'netflix':
                            self.endpointObject.tcpPort = 22;
                            self.endpointObject.udpPort = 33001;
                            self.endpointObject.transferPolicy = '-Q';
                            self.endpointObject.resumePolicy = '0';
                            self.endpointObject.netflixDeliveryInfoExpression = '=subject.netflixDeliveryInfo';
                            break;

                        case 'applenews':
                        case 'gs':
                        case 'ivi':
                        case 'network':
                        case 's3':
                        case 'sftp':
                        case 'uplynk':
                        case 'vantage':
                            break;

                        default:
                            console.warn('Unknown endpoint type: ' + type);
                            break;
                    }

                    deliveryEndpointDeferred.resolve(self.endpointObject);
                    deliveryEndpointPromise = deliveryEndpointDeferred.promise;
                }

                var mediaConversionTemplatesPromise = MediaConversionTemplateService.getAllMediaConversionTemplates();
                return $q.all({
                    partnerObject: partnerPromise,
                    endpointObject: deliveryEndpointPromise,
                    mediaConversionTemplates: mediaConversionTemplatesPromise
                }).then(function (data) {
                    self.endpointObject =
                        data.endpointObject =
                            deliveryEndpointFromDTO(data.endpointObject);
                    self.partnerObject = data.partnerObject;

                    self.originalEndpointData = _.cloneDeep(self.endpointObject);

                    return data;
                });
            };

            self.savePartnerDeliveryEndpoint = function (deliveryEndpoint) {
                var promise;

                if (_.size(deliveryEndpoint.secondaryApiKey) > 0 && !_.size(deliveryEndpoint.secondaryUserName)) {
                    delete deliveryEndpoint.secondaryApiKey;
                }

                if (!!deliveryEndpoint.id) {
                    promise = PartnerResourceFactory.updateDeliveryEndpoint(
                        {
                            endpointId: deliveryEndpoint.id
                        },
                        deliveryEndpoint).$promise;
                } else {
                    promise = PartnerResourceFactory.createDeliveryEndpoint(
                        {
                            partnerId: $routeParams.id
                        },
                        deliveryEndpoint).$promise;
                }
                promise.then(function (newEndpointDTO) {
                    var newEndpoint = deliveryEndpointFromDTO(newEndpointDTO);
                    self.originalEndpointData = _.cloneDeep(newEndpoint);
                    self.endpointObject = _.cloneDeep(newEndpoint);
                    self.editorForm.$setPristine();
                });
                return promise;
            };

            self.revertPartnerDeliveryEndpoint = function () {
                if (self.endpointObject.id) {
                    self.endpointObject = _.cloneDeep(self.originalEndpointData);
                    self.editorForm.$setPristine();
                } else {
                    closeEditView();
                }
            };

            self.getDeliveryEndpointsForPartner = (partnerId, extendedDTO) => {
                if (partnerId >= 0) {
                    return PartnerResourceFactory.getDeliveryEndpoints({
                        id: partnerId,
                        view: extendedDTO? 'EXTENDED': 'MINIMAL'
                    }).$promise;
                } else {
                    return $q.when([]);
                }
            };

            //=================//
            // Email Endpoints //
            //=================//

            self.getEmailEndpointSearchViewData = function (showHidden) {
                var partnerPromise = getPartnerPromise();
                var emailEndpointsPromise =
                    PartnerResourceFactory.getEmailEndpoints({
                        partnerId: $routeParams.id,
                        includeHidden: showHidden
                    }).$promise;

                return $q.all({
                    partnerObject: partnerPromise,
                    emailEndpoints: emailEndpointsPromise
                })
                    .then(function (data) {
                        self.partnerObject = data.partnerObject;
                        return data;
                    });
            };

            self.getEmailEndpointEditData = function () {
                // Get partner
                var partnerPromise = getPartnerPromise();

                // Get email endpoint
                var emailEndpointPromise;
                if ($routeParams.endpointId > -1) {
                    // Get existing email endpoint
                    emailEndpointPromise = PartnerResourceFactory
                        .getEmailEndpoint({
                            id: $routeParams.endpointId
                        }).$promise;
                } else {
                    // Construct new email endpoint
                    var emailEndpointDeferred = $q.defer();
                    emailEndpointDeferred.resolve({});
                    emailEndpointPromise = emailEndpointDeferred.promise;
                }

                // Get email templates
                var emailTemplatesPromise = EmailTemplatesResourceFactory.query().$promise;

                return $q.all({
                    partnerObject: partnerPromise,
                    availableEmailTemplates: emailTemplatesPromise,
                    endpointObject: emailEndpointPromise
                })
                    .then(function (data) {
                        self.partnerObject = data.partnerObject;
                        self.endpointObject = data.endpointObject;
                        self.originalEndpointObject = _.cloneDeep(data.endpointObject);
                        return data;
                    });
            };

            self.saveEmailEndpoint = function (emailEndpoint) {
                var resourceFunc = emailEndpoint.id ? 'updateEmailEndpoint' : 'createEmailEndpoint';
                var params = emailEndpoint.id ? {id: emailEndpoint.id} : {partnerId: self.partnerObject.id};

                return PartnerResourceFactory[resourceFunc](params, emailEndpoint).$promise
                    .then(function (newEndpoint) {
                        self.endpointObject = newEndpoint;
                        self.originalEndpointObject = _.cloneDeep(newEndpoint);
                        self.editorForm.$setPristine();
                        return newEndpoint;
                    });
            };

            self.toggleEmailEndpointVisibility = function (emailEndpointId) {
                return PartnerResourceFactory.toggleEmailEndpointVisibility(
                    {
                        id: emailEndpointId,
                    }
                ).$promise;
            };

            self.cloneEmailEndpoint = function (emailEndpointId) {
                return PartnerResourceFactory.cloneEmailEndpoint(
                    {
                        id: emailEndpointId,
                    }
                ).$promise;
            };

            self.revertEmailEndpoint = function (toRoute) {
                if (self.endpointObject.id) {
                    self.endpointObject = _.cloneDeep(self.originalEndpointObject);
                    self.editorForm.$setPristine();
                } else {
                    closeEditView(toRoute);
                }
            };

            self.getEmailEndpointsForPartner = (partnerId) => {
                if (partnerId >= 0) {
                    return PartnerResourceFactory.getEmailEndpoints({
                        partnerId: partnerId
                    }).$promise;
                } else {
                    return $q.when([]);
                }
            };


            //===============
            // SLA Templates
            //===============

            self.getDueDateTemplatesForPartner = (partnerId, includeHidden = false) => {
                return PartnerResourceFactory.getDueDateTemplates({
                    partnerId: partnerId,
                    includeHidden: includeHidden
                }).$promise;
            };

            self.getDueDateTemplatesSearchViewData = function (showHidden) {
                var partnerPromise = getPartnerPromise();
                var dueDateTemplatesPromise = self.getDueDateTemplatesForPartner(
                    $routeParams.id,
                    showHidden);

                return $q.all({
                    partnerObject: partnerPromise,
                    dueDateTemplates: dueDateTemplatesPromise
                }).then(function (data) {
                    self.partnerObject = data.partnerObject;
                    return data;
                });
            };

            self.cloneDueDateTemplate = (dueDateTemplate) => {
                return PartnerResourceFactory.cloneDueDateTemplate({
                    id: dueDateTemplate.id
                }).$promise;
            };

            self.saveDueDateTemplate = (dueDateTemplate) => {
                var resourceFunc;
                var params;

                if (dueDateTemplate.id) {
                    resourceFunc = 'updateDueDateTemplate';
                    params = {id: dueDateTemplate.id};
                } else {
                    resourceFunc = 'createDueDateTemplate';
                    params = {partnerId: $routeParams.id};
                }

                return PartnerResourceFactory[resourceFunc](params, dueDateTemplate).$promise
                    .then(function (newDueDateTemplateObject) {
                        self.dueDateTemplateObject = newDueDateTemplateObject;
                        self.originalDueDateTemplateObject = _.cloneDeep(newDueDateTemplateObject);
                        self.editorForm.$setPristine();
                        return newDueDateTemplateObject;
                    });
            };

            self.getDueDateTemplatesEditViewData = function () {
                let partnerPromise = getPartnerPromise();

                let dueDateTemplatePromise;
                if ($routeParams.dueDateTemplateId > -1) {
                    dueDateTemplatePromise = PartnerResourceFactory.getDueDateTemplate({
                        id: $routeParams.dueDateTemplateId
                    }).$promise;
                } else {
                    let dueDateTemplateDeferred = $q.defer();
                    dueDateTemplateDeferred.resolve({});
                    dueDateTemplatePromise = dueDateTemplateDeferred.promise;
                }

                let emailTemplatesPromise = EmailTemplatesResourceFactory.query().$promise;

                let businessesPromise = PartnerResourceFactory.getBusinesses().$promise;

                return $q.all({
                    partnerObject: partnerPromise,
                    availableEmailTemplates: emailTemplatesPromise,
                    availableBusinesses: businessesPromise,
                    dueDateTemplateObject: dueDateTemplatePromise
                }).then(function (data) {
                    self.partnerObject = data.partnerObject;

                    self.dueDateTemplateObject = data.dueDateTemplateObject;
                    UtilsService.convertToNumber(self.dueDateTemplateObject, 'warningThresholdHours');
                    self.originalDueDateTemplateObject = _.cloneDeep(data.dueDateTemplateObject);

                    if ($routeParams.dueDateTemplateId < 0) {
                        self.dueDateTemplateObject.business = data.availableBusinesses[0];
                    }

                    return data;
                });
            };

            self.toggleDueDateTemplateVisibility = (dueDateTemplate) => {
                return PartnerResourceFactory.toggleDueDateTemplateVisibility({
                    id: dueDateTemplate.id
                }).$promise;
            };

            self.revertDueDateTemplate = (toRoute) => {
                if (self.dueDateTemplateObject.id) {
                    self.dueDateTemplateObject = _.cloneDeep(self.originalDueDateTemplateObject);
                    self.editorForm.$setPristine();
                } else {
                    closeEditView(toRoute);
                }
            };


            //===================//
            // Nielsen Templates //
            //===================//

            self.getNielsenTemplatesForPartner = (partnerId, includeHidden = false) => {
                return PartnerResourceFactory.getNielsenTemplates({
                    partnerId: partnerId,
                    includeHidden: includeHidden
                }).$promise;
            };

            self.createNielsenTemplate = (partnerId, nielsenTemplate) => {
                return PartnerResourceFactory.createNielsenTemplate({partnerId: partnerId}, nielsenTemplate).$promise;
            };

            self.cloneNielsenTemplate = (nielsenTemplateId) => {
                return PartnerResourceFactory.cloneNielsenTemplate({id: nielsenTemplateId}).$promise;
            };

            self.getNielsenTemplate = (nielsenTemplateId) => {
                return PartnerResourceFactory.getNielsenTemplate({id: nielsenTemplateId}).$promise;
            };

            self.updateNielsenTemplate = (nielsenTemplate) => {
                return PartnerResourceFactory.updateNielsenTemplate(nielsenTemplate).$promise;
            };

            self.toggleNielsenTemplateHidden = (nielsenTemplateId) => {
                return PartnerResourceFactory.toggleNielsenTemplateHidden({id: nielsenTemplateId}).$promise;
            };


            //===================//
            // Delivery Profiles//
            //===================//

            self.getDeliveryProfilesForPartner = (partnerId, includeHidden = false) => {
                return PartnerResourceFactory.getDeliveryProfiles({
                    partnerId: partnerId,
                    includeHidden: includeHidden
                }).$promise;
            };

            self.getDeliveryProfile = (deliveryProfileId, showHiddenEmails = false) => {
                return PartnerResourceFactory.getDeliveryProfile({profileId: deliveryProfileId, includeHiddenEmails: showHiddenEmails}).$promise;
            };
            self.createDeliveryProfile = (partnerId, deliveryProfile) => {
                return PartnerResourceFactory.createDeliveryProfile({partnerId: partnerId}, deliveryProfile).$promise;
            };
            self.updateDeliveryProfile = (deliveryProfile) => {
                return PartnerResourceFactory.updateDeliveryProfile(deliveryProfile).$promise;
            };
            self.toggleDeliveryEmailHidden = (deliveryProfileId, deliveryEmailId) => {
                return PartnerResourceFactory.toggleDeliveryEmailHidden({profileId: deliveryProfileId, id: deliveryEmailId}).$promise;
            };
            self.getDeliveryEmail = (deliveryProfileId, deliveryEmailId) => {
                return PartnerResourceFactory.getDeliveryEmail({profileId: deliveryProfileId, id: deliveryEmailId}).$promise;
            };
            self.updateDeliveryEmail = (deliveryProfileId, deliveryEmail) => {
                return PartnerResourceFactory.updateDeliveryEmail({profileId: deliveryProfileId, id: deliveryEmail.id}, deliveryEmail).$promise;
            };
            self.createDeliveryEmail = (deliveryProfileId, deliveryEmail) => {
                return PartnerResourceFactory.createDeliveryEmail({profileId: deliveryProfileId}, deliveryEmail).$promise;
            };
            self.getDeliveryItemsForProfile = (criteria) => {
                return PartnerResourceFactory.getDeliveryItemsForProfile(criteria, (gridData, responseHeaders) => {
                    PaginationService.parseResponseHeaders(responseHeaders());
                    PaginationService.pageData = gridData;
                }).$promise;
            };
            self.toggleDeliveryItemHidden = (deliveryProfileId) => {
                return PartnerResourceFactory.toggleDeliveryItemHidden({id: deliveryProfileId}).$promise;
            };
            self.cloneDeliveryItem = (deliveryProfileId) => {
                return PartnerResourceFactory.cloneDeliveryItem({id: deliveryProfileId}).$promise;
            };
            self.getDeliveryItem = (id) => {
                return PartnerResourceFactory.getDeliveryItem({id: id}).$promise;
            };
            self.updateDeliveryItem = (deliveryItem) => {
                return PartnerResourceFactory.updateDeliveryItem({id: deliveryItem.id}, deliveryItem).$promise;
            };
            self.createDeliveryItem = (deliveryItem) => {
                return PartnerResourceFactory.createDeliveryItem(deliveryItem).$promise;
            };


            //===============//
            // Service Entry //
            //===============//

            if (BreadcrumbService.getBreadcrumbs().length === 0) {
                self.resetBreadcrumbs();
            }


        });
